import React from 'react';
import styles from './Stripo.module.css';

interface StripoEditorProps {
  containerRef: React.RefObject<HTMLDivElement>;
  showSaving: boolean;
}

export const StripoEditor: React.FC<StripoEditorProps> = ({ containerRef, showSaving }) => {
  return (
    <div className={styles.editorWrapper}>
      {showSaving && (
        <div className={styles.savingOverlay}>
          <div className={styles.spinner} />
          <span>Saving...</span>
        </div>
      )}

      <div
        id="stripoEditorContainer"
        ref={containerRef}
        className={styles.editorContainer}
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
};
